// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2smXU","col":"styles_col__20cV7"};